var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"att-header pt-3 pb-2"},[_vm._l((_vm.menulist),function(item,index){return [_c('p',{key:index,class:{ active: _vm.pathName == item.path },on:{"click":function($event){return _vm.changeMenu(item.path)}}},[_vm._v(" "+_vm._s(item.name)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }